import { useState } from "react";
import {
  IPhoneOrder, IPhoneOrderLedgerItem, PHONE_PAYMENT_METHODS, phonePaymentLabel,
} from "../models/IPhoneOrder";
import { phoneErrorMessage, updatePhoneOrderPaymentMethod } from "../services/phoneOrderService";

const FIX_ERROR: Record<string, string> = {
  PhoneOrderNotFound: "Bu sipariş bulunamadı. Listeyi yenileyin.",
  NotAPhoneOrder: "Bu bir telefon siparişi değil; ödeme yöntemi buradan değiştirilemez.",
  PaymentMethodCannotBeUnspecified: "Belirlenmedi durumuna geri dönülemez.",
  PhoneOrderCancelled: "İptal edilmiş siparişin ödeme yöntemi girilemez.",
  PaymentMethodNotAllowed: "Telefon siparişinde yalnızca Nakit ve Kapıda Kredi Kartı seçilebilir.",
  RestourantAccessDenied: "Bu siparişte işlem yapma yetkiniz yok.",
};

interface Props {
  order: IPhoneOrderLedgerItem;
  onClose: () => void;
  onUpdated: (order: IPhoneOrder) => void;
}

export default function PhoneOrderPaymentModal({ order, onClose, onUpdated }: Props) {
  const currentId = order.isPaymentMethodSpecified ? order.paymentMethodId.toLowerCase() : "";
  const [selected, setSelected] = useState(currentId);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!selected) { setError("Bir ödeme yöntemi seçin."); return; }
    setSaving(true);
    setError("");
    updatePhoneOrderPaymentMethod(order.orderId, selected)
      .then((res) => { onUpdated(res.data); onClose(); })
      .catch((err) => setError(phoneErrorMessage(err, FIX_ERROR, "Ödeme yöntemi kaydedilemedi.")))
      .finally(() => setSaving(false));
  };

  return (
    <div className="dinein-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget && !saving) onClose(); }}>
      <div className="dinein-modal dinein-modal--narrow">
        <div className="dinein-modal__head">
          <div>
            <div className="dinein-modal__title"><i className="bi bi-wallet2 me-2"></i>Ödeme Yöntemi</div>
            <div className="dinein-modal__sub">{order.orderCode} · {order.customerFullName}</div>
          </div>
          <button className="dinein-icon-btn" onClick={onClose} disabled={saving}><i className="bi bi-x-lg"></i></button>
        </div>

        <div className="dinein-modal__body">
          <div className="po-fix__current">
            <span>Şu anki</span>
            <strong>{phonePaymentLabel(order.paymentMethodId, order.paymentMethodNameTr)}</strong>
          </div>

          <div className="pay-methods">
            <div className="pay-methods__label">Yeni yöntem</div>
            <div className="pay-methods__options">
              {PHONE_PAYMENT_METHODS.map((m) => (
                <button key={m.id} type="button"
                  className={`pay-method${selected === m.id ? " pay-method--active" : ""}`}
                  disabled={saving}
                  onClick={() => { setSelected(m.id); setError(""); }}>
                  {selected === m.id && <i className="bi bi-check-circle-fill pay-method__check"></i>}
                  <i className={`bi ${m.icon}`}></i>
                  <span>{m.label}</span>
                </button>
              ))}
            </div>
          </div>

          {!order.isPaymentMethodSpecified && (
            <div className="dinein-alert dinein-alert--warn">
              <i className="bi bi-exclamation-triangle-fill"></i>
              <span>Kaydedince "Belirlenmedi"ye dönülemez; Nakit ve kart arasında sonradan değiştirilebilir.</span>
            </div>
          )}

          {error && (
            <div className="dinein-alert dinein-alert--error"><i className="bi bi-exclamation-circle-fill"></i><span>{error}</span></div>
          )}
        </div>

        <div className="dinein-modal__foot">
          <button className="dinein-btn dinein-btn--ghost" onClick={onClose} disabled={saving}>Vazgeç</button>
          <button className="dinein-btn dinein-btn--primary" onClick={handleSubmit}
            disabled={saving || !selected || selected === currentId}>
            {saving
              ? <><span className="spinner-border spinner-border-sm me-1" />Kaydediliyor...</>
              : <><i className="bi bi-check-lg me-1"></i>Kaydet</>}
          </button>
        </div>
      </div>
    </div>
  );
}
